<template>
  <v-dialog v-model="showDeleteDocumentDialog" max-width="390">
    <v-card v-if="prepared === true && document">
      <span style="float:right" class="ma-4">
        <v-icon v-on:click="discard()">clear</v-icon>
      </span>
      <v-card-title>
        <span class="body-2">Sind Sie absolut sicher?</span>
      </v-card-title>
      <v-card-text>
        <p>
          Das Dokument<br />{{ document.name }}<br />Erstellt {{ document.tstamp | moment("[am] L [um] LTS [Uhr]")
          }}<br />
          wird unwiderbringlich gelöscht.
        </p>
        <p>
          Möchten Sie wirklich fortfahren?
        </p>
      </v-card-text>
      <div class="text-center">
        <v-card-actions>
          <v-btn color="error" v-on:click="onClickDelete()">Dokument Löschen</v-btn>
        </v-card-actions>
      </div>
    </v-card>
    <v-card v-if="deleting === true">
      <v-card-title>
        <span class="body-2">Löschvorgang</span>
      </v-card-title>
      <v-card-text>
        <v-progress-linear indeterminate></v-progress-linear>
        <p>Dokument wird gelöscht</p>
      </v-card-text>
    </v-card>
    <v-card v-if="deleteDone == true">
      <v-card-title>
        <span class="body-2">Löschen erfolgreich</span>
      </v-card-title>
      <v-card-text>
        <span><v-icon color="success">check</v-icon></span>
        <span>Dokument wurde gelöscht.</span>
      </v-card-text>
    </v-card>
    <v-card v-if="deleteError == true">
      <v-card-title>
        <span class="body-2">Löschen fehlgeschlagen</span>
      </v-card-title>
      <v-card-text>
        <span><v-icon color="error">mdi-alert-circle-outline</v-icon></span>
        <span>Dokument wurde gelöscht.</span>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DocumentDeleteView",
  props: {
    document: Object,
    prefix: String,
    showThis: Boolean,
  },
  watch: {
    showThis: function(st) {
      this.showDeleteDocumentDialog = st;
      if (st) {
        this.init();
      }
    },
    showDeleteDocumentDialog: function(show) {
      if (show === false) {
        this.$emit("discard");
      }
    },
  },
  methods: {
    init() {
      this.prepared = true;
      this.deleting = false;
      this.deleteDone = false;
    },
    onClickDelete() {
      this.prepared = false;
      this.deleting = true;
      this.$eventHub.emit("sync-status-syncing");
      let name = this.document.name;
      this.$Amplify.Storage.remove(this.prefix + name, { level: "private" })
        .then((result) => {
          this.$eventHub.emit("sync-status-success", {
            entity_type: "Dokument",
            entity_label: name,
            sync_type: "delete",
          });
          this.deleting = false;
          this.deleteDone = true;
          this.deleteDoneCB();
        })
        .catch((err) => {
          this.$eventHub.emit("sync-status-failure", {
            entity_type: "Dokument",
            entity_label: name,
            sync_type: "delete",
            error: err.errors[0].message,
          });
          this.deleting = false;
          this.deleteError = true;
        });
    },
    deleteDoneCB(result) {
      setTimeout(() => {
        this.$emit("didDelete");
        this.showDeleteDocumentDialog = false;
      }, 2000);
    },
    discard() {
      this.showDeleteDocumentDialog = false;
    },
  },
  data: () => ({
    prepared: true,
    deleting: false,
    deleteDone: false,
    deleteError: false,
    showDeleteDocumentDialog: false,
  }),
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped></style>
